/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Loading_Older_MessagesInputs */



/**
* | output |
* | --- |
* | "Loading older messages…" |
*
* @param {Chat_Loading_Older_MessagesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_loading_older_messages = /** @type {((inputs?: Chat_Loading_Older_MessagesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Loading_Older_MessagesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ältere Nachrichten werden geladen…")
	return /** @type {LocalizedString} */ ("Loading older messages…")
});